import { useState, type FormEvent } from "react";
import { Mail } from "lucide-react";
import { getSupabaseClient } from "@veorest/api-client";
import { AdminAuthLayout } from "../components/auth/AdminAuthLayout";
import { AuthField, AuthSubmit } from "../components/auth/AuthField";
import { ROUTES } from "../routes";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      const supabase = getSupabaseClient();
      const redirectTo = `${window.location.origin}${ROUTES.RESET_PASSWORD}`;
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo,
      });
      if (resetError) {
        setError(resetError.message);
        return;
      }
      setSent(true);
    } catch {
      setError("Could not send reset email.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminAuthLayout
      title="Forgot password"
      subtitle="We’ll email a secure reset link to your admin inbox."
      footerPrompt="Remembered it?"
      footerLinkLabel="Sign in"
      footerLinkTo={ROUTES.LOGIN}
    >
      {error ? <div className="pill pill-danger mb-4 w-full justify-center">{error}</div> : null}
      {sent ? (
        <div className="pill pill-success mb-4 w-full justify-center">
          If that email is registered, a reset link is on its way.
        </div>
      ) : null}

      <form onSubmit={handleSubmit} className="auth-form space-y-4">
        <AuthField
          id="reset-email"
          label="Admin email"
          type="email"
          icon={Mail}
          value={email}
          onChange={setEmail}
          placeholder="admin@oelox.com"
          required
        />
        <AuthSubmit loading={isSubmitting || sent}>
          {isSubmitting ? "Sending…" : sent ? "Email sent" : "Send reset link"}
        </AuthSubmit>
      </form>
    </AdminAuthLayout>
  );
}
